export interface IChangeCategoriesOrder {
    data: {
        category_id: string;
        sort_order: string;
    }[];
}
